import { toSafeString } from '@shared/utils';

const toAttachmentInputItem = ({ uploadResult } = {}) => {
  if (!uploadResult || typeof uploadResult !== 'object') {
    return null;
  }

  const attachmentId = toSafeString(uploadResult.attachmentId);
  const mediaKind = toSafeString(uploadResult.mediaKind).toLowerCase();

  if (!attachmentId || (mediaKind !== 'image' && mediaKind !== 'document')) {
    return null;
  }

  return {
    type: 'file',
    attachmentId,
    mediaKind,
    attachment: {
      attachmentId,
      mediaKind,
      filename: toSafeString(uploadResult.filename) || 'attachment',
      mimeType: toSafeString(uploadResult.mimeType) || 'application/octet-stream',
      sizeBytes: Number(uploadResult.sizeBytes) || 0
    }
  };
};

export default toAttachmentInputItem;
